import React from 'react'
import {
  ConsoleCard,
  CardsCol,
  CardsRow,
  PageHeading,
  Page,
  Tabs,
  TabsProps,
} from 'admin-web-ui'
import { IOSVendorIdLookupForm } from './IOSVendorIdLookupForm'
import styled from 'styled-components'
import { AndroidVendorIdLookupForm } from './AndroidVendorIdLookupForm'

const StyledTabs = styled(Tabs)`
  margin: -24px 0px 0;
  .ant-tabs-bar.ant-tabs-top-bar {
    padding-left: 24px;
    padding-right: 24px;
    border-bottom: solid ${({ theme }) => theme.greys.geyser} 1px;
  }
  .ant-tabs-tabpane {
    padding-left: 24px;
    padding-right: 24px;
  }
  .ant-tabs-tab {
    padding: 24px 0;
    &.ant-tabs-tab-active {
      color: #000;
      font-weight: 600;
    }
  }
  .ant-tabs-ink-bar {
    background-color: ${({ theme }) => theme.colors.sudoBlue};
  }
`

const items: TabsProps['items'] = [
  {
    key: 'ios',
    label: 'iOS',
    children: (
      <>
        <ConsoleCard.Heading>iOS Vendor ID Lookup</ConsoleCard.Heading>
        <ConsoleCard.SubHeading>
          Use the iOS Vendor ID to look up a device and view its registration
          and whitelist status.
        </ConsoleCard.SubHeading>
        <IOSVendorIdLookupForm />
      </>
    ),
  },
  {
    key: 'android',
    label: 'Android',
    children: (
      <>
        <ConsoleCard.Heading>Android Vendor ID Lookup</ConsoleCard.Heading>
        <ConsoleCard.SubHeading>
          Use the Android Vendor ID to look up a device and view its registion
          status.
        </ConsoleCard.SubHeading>
        <AndroidVendorIdLookupForm />
      </>
    ),
  },
]

export const RegistrationSupport: React.FC = () => {
  return (
    <Page>
      <PageHeading>Registrations Support</PageHeading>
      <CardsRow>
        <CardsCol span={24}>
          <ConsoleCard>
            <StyledTabs defaultActiveKey="ios" items={items} />
          </ConsoleCard>
        </CardsCol>
      </CardsRow>
    </Page>
  )
}
